/**
 * Feedback service — submit in-app issue reports and feature requests
 * (with optional image attachments) to the backend.
 */

import { BaseService } from './baseService'

export type FeedbackCategory = 'issue' | 'feature'

export interface FeedbackSubmission {
  category: FeedbackCategory
  message: string
  images?: File[]
  pageUrl?: string
}

export interface FeedbackResponse {
  id: number
  category: FeedbackCategory
  message: string
  page_url: string
  status: string
  created_at: string
}

class FeedbackService extends BaseService {
  /** Create a feedback submission. Sends multipart so images can be attached. */
  async submit(input: FeedbackSubmission): Promise<FeedbackResponse> {
    const form = new FormData()
    form.append('category', input.category)
    form.append('message', input.message)
    form.append('page_url', input.pageUrl ?? window.location.href)
    for (const image of input.images ?? []) {
      form.append('uploaded_images', image, image.name)
    }
    return this.requestWithRefresh<FeedbackResponse>('/feedback/', {
      method: 'POST',
      body: form,
    })
  }
}

export const feedbackService = new FeedbackService()
